import { render, staticRenderFns } from "./CancelMyPayment.vue?vue&type=template&id=13d3fd2a"
import script from "./CancelMyPayment.vue?vue&type=script&lang=js"
export * from "./CancelMyPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports